import { motion, useMotionValue, useSpring } from "framer-motion";

export const MagneticButton = ({ children, className = "", onClick, strength = 0.25, ...props }) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 160, damping: 16, mass: 0.2 });
  const sy = useSpring(y, { stiffness: 160, damping: 16, mass: 0.2 });

  const handleMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * strength);
    y.set((e.clientY - r.top - r.height / 2) * strength);
  };
  const reset = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.button
      style={{ x: sx, y: sy }}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      onClick={onClick}
      className={className}
      {...props}
    >
      {children}
    </motion.button>
  );
};
